import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { TotalProductionPlants } from '../../components/plants/ui/productionplants';
// import {Apps} from '~/features/apps';
// import {AppHeader} from '~/widgets/ui';
// import {withTariff} from '~/shared/lib/hoc/with-tariff';
// import compose from 'compose-function';
// Приложения страница
const PlantsProductionPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Производство</title>
            </Helmet>
            <TotalProductionPlants/>
            {/* <AppHeader title={t('apps')} /> */}
            {/* <Apps /> */}
        </>
    );
};

export default PlantsProductionPage
